"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _Link = _interopRequireDefault(require("../../elements/Link/Link"));
var _HorizontalDivider = _interopRequireDefault(require("../../elements/horizontal-divider/Horizontal-Divider"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _PageGrid = _interopRequireDefault(require("../../layouts/Skeletons/PageGrid/PageGrid"));
var _excluded = ["subsectionCopy"],
  _excluded2 = ["headingCopy", "version", "imageData"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var StyledPageGrid = (0, _styledComponents.default)(_PageGrid.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n  border-top: transparent;\n  border-bottom: transparent;\n  border-left: transparent;\n  border-left-width: 0px !important;\n  border-right: transparent;\n  border-right-width: 0px !important;\n  border-width: thick;\n  border-style: solid;\n  padding-top: 25px;\n  padding-bottom: 25px;\n"])));
var StyledItemGrid = (0, _styledComponents.default)(_Grid.default)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"])));
var StyledSectionHeading = (0, _styledComponents.default)(_Heading.default)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"])));
var StyledSectionSubheading = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children;
  return _react.default.createElement(_Heading.default, {
    hsub: true,
    special: true,
    white: true,
    className: className
  }, " ", children, " ");
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"])));
var StyledLogo = _styledComponents.default.img(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  max-width: 100%;\n  max-height: 150px;\n  text-align: center;\n\n  @media (min-width: ", ") {\n  }\n\n  @media (min-width: ", ") {\n  }\n"])), _bfBaseStyles.Breakpoints.m, _bfBaseStyles.Breakpoints.l);
var OptionalSubsection = function OptionalSubsection(_ref2) {
  var subsectionCopy = _ref2.subsectionCopy,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_HorizontalDivider.default, {
    dividerwhite: true
  }), _react.default.createElement(StyledSectionSubheading, props, subsectionCopy));
};
function sortImages(order_1, order_2) {
  var comparison = 0;
  var logoOne = order_1.data.section_order;
  var logoTwo = order_2.data.section_order;
  if (logoOne > logoTwo) {
    comparison = 1;
  } else if (logoOne < logoTwo) {
    comparison = -1;
  }
  return comparison;
}
var ThreeWidths = [4, 3, 5];
var FourWidths = [2, 3, 3, 3];
var SingleRowLogos = function SingleRowLogos(_ref3) {
  var headingCopy = _ref3.headingCopy,
    version = _ref3.version,
    imageData = _ref3.imageData,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded2);
  var holdWidths = version == 'EducationOrganizations' ? ThreeWidths : FourWidths;
  console.log("HEY GURLLLLLLLLLLLL ".concat(JSON.stringify(imageData)));
  return _react.default.createElement(StyledPageGrid, props, version == 'Companies' ? _react.default.createElement(StyledSectionHeading, Object.assign({
    h1: true,
    white: true,
    xs: 12
  }, props), headingCopy) : _react.default.createElement(StyledSectionHeading, Object.assign({
    h1: true,
    pink: true,
    xs: 12
  }, props), headingCopy), version == 'Companies' ? _react.default.createElement(OptionalSubsection, Object.assign({
    subsectionCopy: props.subheadingCopy
  }, props)) : _react.default.createElement(_react.default.Fragment, null), _react.default.createElement(_Grid.default, Object.assign({
    container: true,
    alignItems: "center",
    justifyContent: "space-between"
  }, props), imageData.sort(sortImages).map(function (imageItem) {
    return _react.default.createElement(StyledItemGrid, {
      item: true,
      xs: 12,
      sm: 12,
      md: holdWidths[imageItem.data.section_order - 1]
    }, _react.default.createElement(_Link.default, {
      href: imageItem.data.redirect_url
    }, _react.default.createElement(StyledLogo, {
      src: imageItem.data.url,
      alt: imageItem.data.alt_text
    })));
  })));
};
var _default = SingleRowLogos;
exports.default = _default;